module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-1",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "raised": ""
    }
  }, [_c('v-card-media', {
    attrs: {
      "src": "/static/img/paisaje.jpg",
      "height": "300px"
    }
  }, [_c('v-layout', {
    staticClass: "media",
    attrs: {
      "column": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-card-title', {
    staticClass: "white--text pl-5 pt-5"
  }, [_c('div', {
    staticClass: "display-1 pl-5 pt-5"
  }, [_vm._v("Jose Ángel Hermosilla Rodrigo")])])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "href": "https://github.com/joseahr",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github fa-2x"
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "href": "https://stackoverflow.com/users/3866134/jose-hermosilla-rodrigo?tab=profile",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-stack-overflow fa-2x"
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "href": "https://www.facebook.com/jose.hermosillarodrigo",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook fa-2x"
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "href": "https://www.instagram.com/josehermosillarodrigo/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram fa-2x"
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "href": "https://www.linkedin.com/in/jose-%C3%A1ngel-hermosilla-rodrigo-70a590147/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin fa-2x"
  })])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', {
    on: {
      "click": function($event) {}
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "color": "indigo"
    }
  }, [_vm._v("mail")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("joherro123@gmail.com")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Personal")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {}
    }
  }, [_c('v-list-tile-action'), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("joherro3@topo.upv.es")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Universidad")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {}
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "color": "indigo"
    }
  }, [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("España")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Torrent, Valencia 46900")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _vm._l((_vm.estudios), function(estudio) {
    return _c('v-list-tile', {
      key: estudio.title,
      attrs: {
        "three-lines": ""
      },
      on: {
        "click": function($event) {}
      }
    }, [_c('v-list-tile-action', [(estudio.icon) ? _c('v-icon', {
      attrs: {
        "color": "indigo"
      }
    }, [_vm._v(_vm._s(estudio.icon))]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(estudio.title)
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s(estudio.centro)
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s(estudio.periodo)
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('v-divider')], 2), _vm._v(" "), _c('v-card-text', [_c('b', [_vm._v("Conocimientos")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, _vm._l((_vm.conocimientos), function(conocimiento) {
    return _c('v-chip', {
      key: conocimiento,
      attrs: {
        "color": "primary",
        "text-color": "white"
      }
    }, [_vm._v(_vm._s(conocimiento))])
  })), _vm._v(" "), _c('b', [_vm._v("Tecnologías Usadas")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, _vm._l((_vm.tecnologias), function(tecnologia) {
    return _c('v-chip', {
      key: tecnologia,
      attrs: {
        "color": "primary",
        "text-color": "white"
      }
    }, [_vm._v(_vm._s(tecnologia))])
  })), _vm._v(" "), _c('b', [_vm._v("StackOverflow")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('a', {
    attrs: {
      "href": "https://stackexchange.com/users/4785502"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://stackexchange.com/users/flair/4785502.png",
      "width": "208",
      "height": "58",
      "alt": "profile for Jose Hermosilla Rodrigo on Stack Exchange, a network of free, community-driven Q&A sites",
      "title": "profile for Jose Hermosilla Rodrigo on Stack Exchange, a network of free, community-driven Q&A sites"
    }
  })])])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18152be8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
// module id = 261
// module chunks = 1